export default class CardRequiredModel {
    constructor() {
        this.odometerRequired = undefined;
        this.driverRequired = undefined;
        this.vehicleRequired = undefined;
        this.mpkRequired = undefined;
    }

    static assign(from, to) {
        if (from) {
            to.odometerRequired = from.odometerRequired ? from.odometerRequired : undefined;
            to.driverRequired = from.driverRequired ? from.driverRequired : undefined;
            to.vehicleRequired = from.vehicleRequired ? from.vehicleRequired : undefined;
            to.mpkRequired = from.mpkRequired ? from.mpkRequired : undefined;
        } else {
            to = new CardRequiredModel();
        }
    }

    static copy(from) {
        const to = new CardRequiredModel();
        CardRequiredModel.assign(from, to);
        return to;
    }
}